import { render, staticRenderFns } from "./BannerContabilidad.vue?vue&type=template&id=0c94d574&scoped=true"
import script from "./BannerContabilidad.vue?vue&type=script&lang=js"
export * from "./BannerContabilidad.vue?vue&type=script&lang=js"
import style0 from "./BannerContabilidad.vue?vue&type=style&index=0&id=0c94d574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c94d574",
  null
  
)

export default component.exports